import { render } from "./FooterInquiry.vue?vue&type=template&id=0129e512&scoped=true"
import script from "./FooterInquiry.vue?vue&type=script&lang=js"
export * from "./FooterInquiry.vue?vue&type=script&lang=js"

import "./FooterInquiry.vue?vue&type=style&index=0&id=0129e512&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0129e512"]])

export default __exports__